import { ORGANIZATIONS_SORT } from '@jebel/constants';

export const ORGANIZATION_SORT_OPTIONS = Object.keys(ORGANIZATIONS_SORT).map((sortKey: string) => {
  return {
    label: ORGANIZATIONS_SORT[sortKey],
    value: ORGANIZATIONS_SORT[sortKey],
  };
});
